import { useState, useEffect } from 'react';
import { POSService } from '../services/pos/posService';
import { createPOSService } from '../services/pos/posService';
import { POSConfig } from '../services/pos/types';

/**
 * Hook to create and manage POS service instance
 */
export function usePOSService(restaurantId: string | undefined, posConfig: POSConfig | undefined) {
  const [posService, setPosService] = useState<POSService | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!restaurantId || !posConfig) {
      setPosService(null);
      return;
    }

    try {
      const service = createPOSService(restaurantId, posConfig);
      setPosService(service);
      setError(null);
      console.log('✅ POS Service initialized for customer view:', posConfig.provider);
    } catch (err) {
      console.error('❌ Failed to initialize POS service:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
      setPosService(null);
    }
  }, [restaurantId, posConfig]);

  return { posService, error };
}
